import { useContext } from "react";
import AuthContext from "../context/AuthProvider";

// hook usado para evitar que se faça 2 imports 2 instancie a variavel sempre nas varias paginas

const useAuth = () => {
    return useContext(AuthContext);
}

export default useAuth;